module.exports = {
	ResponseCode: {
		'500': 'Internal Server Error',
		'503': 'Server Overload',
		'403': 'Server Unavailable',
		'401': 'UnAuthorized',
		'400': 'Bad Request',
		'408': 'Request Timeout',
		'200': 'Success'
	},
	sessionVariables: {
		UserData: 'UserData',
		POSideFilterData: 'POSideFilterData',
		ClaimSideFilterData: 'ClaimSideFilterData',
		PurchaseOrderNumber: 'PurchaseOrderNumber',
		ClaimNumber: 'ClaimNumber',
		CertNumber: 'CertNumber',
		ClaimRedirectFrom: 'ClaimRedirectFrom',
	},
	ClaimStatusOptions: [
		{name: 'PENDING', value: 'PD'},
		{name: 'COMPLETED', value: 'CL'},
		{name: 'HOLD', value: 'HD'},
		{name: 'DECLINED', value: 'DL'},
		{name: 'FIRST YEAR', value: 'FY'},
		{name: '1ST YEAR PENDING', value: 'FP'},
		{name: 'NO SERVICE REQUEST', value: 'NS'},
		{name: 'COMPLETED DENIED', value: 'CD'},
		{name: 'PARTIAL COMPLETED', value: 'PC'}
	],
	PoStatusOptions: [
		{name: 'INITIATED', value: 'IN'},
		{name: 'NOT AVAILABLE', value: 'NA'},
		{name: 'CANCELED', value: 'CL'},
		{name: 'COMPLETED', value: 'CD'},
		{name: 'PROCESS ORDER', value: 'PR'}
	],
	PoSideFilterMapping: {
		status: 'sDisposition',
        firstName: 'FName',
        lastName: 'LName',
        name: 'FName',
        phone: 'Phone',
        certificate: 'Certificate',
		poNumber: 'purchaseorders.uniquekey',
        claimNumber: 'purchaseorders.iclaim',
        address: 'Address1',
        city: 'City',
        state: 'State',
        zip: 'Zip',
        invoiceNumber: 'InvoiceNum',
        locStore: 'LocStore',
        authorizationNumber: 'Autho'
	},
	ClaimSideFiltersMapping: {
		status: 'claimStatus',
        firstName: 'FName',
        lastName: 'LName',
        name: 'FName',
        phone: 'Phone',
        certificate: 'Certificate',
        claimNumber: 'a.uniquekey',
        poNumber: 'pono',
        address: 'a.Address1',
        city: 'a.City',
        state: 'a.State',
        zip: 'a.Zip',
        invoiceNumber: 'InvoiceNum',
        locStore: 'LocStore',
        authorizationNumber: 'Autho'
	},
	ClaimSortingMapping: {
		status: 'sDisposition',
        firstName: 'FName',
        lastName: 'LName',
        name: 'FName',
        phone: 'Phone',
        certificate: 'Certificate',
        claimNumber: 'uniquekey',
        address: 'Address1',
        city: 'City',
        state: 'State',
        zip: 'Zip',
        invoiceNumber: 'InvoiceNum',
        locStore: 'LocStore',
        authorizationNumber: 'Autho'
	},
};